const DEFAULT_CONTENT_API_REGION = 'asia-southeast1';

/**
 * Base URL of the Content API deployment serving a customer.
 * @param region - The customer's Content API region, if one is set
 */
export const getContentApiBaseUrl = (region?: string | null): string =>
    `https://content.${region || DEFAULT_CONTENT_API_REGION}.api.aampe.com/v1`;
